import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getDepartmentResponse from '@/types/responses/getDepartment';
import getVehicleResponse from '@/types/responses/getVehicle';
import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, computed } from 'vue';
import i18n from '@/lang/i18n';

type ItemType = {
  number_plate: string;
  managementOfficeId: number;
  managementOfficeType: string;
  operationOfficeId: number;
  digital_tacograph: number;
  department_id: number | null;
  id: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleAutoComplete',
  props: {
    modelValue: {},
    selectedDepartment: {},
    managementOffice: {},
    operationOffices: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<ItemType[]>([]);

onMounted(() => {
  Api()
    .autoComplete.temperatureSensorVehicles()
    .then((data) => {
      items.value = data.map((item: getVehicleResponse) => {
        return {
          number_plate: item.number_plate,
          managementOfficeId: item.management_officeable_id,
          managementOfficeType: item.management_officeable_type,
          operationOfficeId: item.operation_office_id,
          digital_tacograph: item.digital_tacograph,
          id: item.id,
          department_id: item.department_id,
          sensor_setting: {
            max_scale: item.sensor_setting?.max_scale,
            min_scale: item.sensor_setting?.min_scale
          }
        };
      });
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByDepartment = computed(() => {
  if (!props.selectedDepartment) {
    return items.value
  }

  return items.value.filter(item => item.department_id === props.selectedDepartment?.id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: _unref(i18n).global.t('pages.temperatureSensors.charts.autocomplete.vehicle'),
    itemName: "number_plate",
    items: filteredByDepartment.value,
    managementOffice: __props.managementOffice,
    operationOffices: props.operationOffices,
    errorMessages: __props.errorMessages
  }, null, 8, ["modelValue", "label", "items", "managementOffice", "operationOffices", "errorMessages"]))
}
}

})